module.exports = __webpack_public_path__ + "assets/mam2.jpg?c5a1f4532d2513132b37bd8121ce9347";